import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "order-calling"
};
const _hoisted_2 = {
  class: "main-wrap"
};
const _hoisted_3 = {
  class: "header-bar"
};
const _hoisted_4 = {
  key: 0,
  class: "route-info"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
}, null, -1);
const _hoisted_7 = {
  class: "address"
};
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
}, null, -1);
const _hoisted_10 = {
  class: "address"
};
const _hoisted_11 = {
  class: "mapContainer"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "breathe"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "breathe-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "breathe-inside"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "breathe-outside"
})])], -1);
const _hoisted_15 = {
  class: "map-button"
};
const _hoisted_16 = {
  key: 0,
  class: "button left-button"
};
const _hoisted_17 = {
  class: "button wait-button"
};
const _hoisted_18 = {
  class: "bottom-wrap calling-bottom-wrap"
};
const _hoisted_19 = {
  class: "bottom-main"
};
const _hoisted_20 = {
  class: "card-bold tip-info"
};
const _hoisted_21 = {
  class: "card-bold calling-show"
};
const _hoisted_22 = {
  class: "status"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 正在为您呼叫附近的司机 ", -1);
const _hoisted_24 = {
  class: "subText"
};
const _hoisted_25 = {
  class: "card-bold vehicle-type-list"
};
const _hoisted_26 = {
  key: 0,
  class: "vehicle-type-data"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "info"
};
const _hoisted_30 = {
  class: "name"
};
const _hoisted_31 = {
  class: "description"
};
const _hoisted_32 = {
  class: "price"
};
const _hoisted_33 = {
  class: "amount"
};
const _hoisted_34 = {
  key: 0,
  class: "tolls"
};
const _hoisted_35 = {
  key: 1,
  style: {
    "margin-top": "24px"
  }
};
const _hoisted_36 = {
  key: 0,
  class: "title"
};
const _hoisted_37 = {
  key: 1,
  class: "vehicle-type-data"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["src"];
const _hoisted_40 = {
  class: "info"
};
const _hoisted_41 = {
  class: "name"
};
const _hoisted_42 = {
  class: "description"
};
const _hoisted_43 = {
  class: "price"
};
const _hoisted_44 = {
  class: "amount"
};
const _hoisted_45 = {
  key: 0,
  class: "tolls"
};
const _hoisted_46 = ["src", "onClick"];
const _hoisted_47 = {
  class: "card call-options"
};
const _hoisted_48 = {
  key: 1,
  class: "separate"
};
const _hoisted_49 = {
  key: 3,
  class: "separate"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_tip_form = _resolveComponent("tip-form");
  const _component_van_popup = _resolveComponent("van-popup");
  const _directive_height_animate = _resolveDirective("height-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "button back-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    color: "#333"
  })]), $setup.orderType !== 'ORDER_TYPE_VOICE' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString($setup.startAddress), 1)]), _createVNode(_component_van_icon, {
    class: "line",
    name: "down"
  }), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString($setup.endAddress), 1)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("img", {
    class: "pin-img",
    src: require('@/assets/icon/map/map-pin-point.png')
  }, null, 8, _hoisted_13), _hoisted_14, _createElementVNode("div", _hoisted_15, [false ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_van_icon, {
    class: "security",
    name: require('@/assets/icon/security.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "button right-button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.getCurrentPosition && $options.getCurrentPosition(...args)),
    style: {
      "display": "none"
    }
  }, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/map/aim.svg')
  }, null, 8, ["name"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_icon, {
    name: "clock-o"
  }), _createTextVNode(" 已等待" + _toDisplayString($options.CommonUtil.formatSeconds($setup.waitTime, true)), 1)])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/map/tip.png')
  }, null, 8, ["name"]), _createTextVNode(" 为了良好的乘车环境，建议您在后排落座 ")]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [$setup.callLevel === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(" 附近的司机很快就来 ")], 64)) : _createCommentVNode("", true), $setup.callLevel === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(" 当前已经扩大司机范围 ")], 64)) : _createCommentVNode("", true), $setup.callLevel === 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createTextVNode(" 当前已经进一步扩大司机范围 ")], 64)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_25, [$setup.vehicleTypeCheckedCount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vehicleTypes, (vehicleType, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: vehicleType,
      onClick: $event => $options.checkVehicleType(index),
      class: "data"
    }, [vehicleType.checked ? (_openBlock(), _createElementBlock("div", {
      class: "vehicle-type-item checked",
      key: index
    }, [_createElementVNode("img", {
      class: "icon",
      src: vehicleType.icon
    }, null, 8, _hoisted_28), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(vehicleType.name), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(vehicleType.description), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_van_icon, {
      name: "info-o"
    }), _createTextVNode(" " + _toDisplayString(vehicleType.pricePrefix) + " ", 1), _createElementVNode("strong", null, _toDisplayString($setup.vehiclePrices[index] ? $setup.vehiclePrices[index] : '--'), 1), _createTextVNode(" 元 ")]), $setup.tolls && $setup.tolls > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createTextVNode(" 包含"), _createElementVNode("strong", null, _toDisplayString(parseFloat($setup.tolls).toFixed(2)), 1), _createTextVNode("元通行费 ")])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 8, _hoisted_27);
  }), 128))])) : _createCommentVNode("", true), $setup.orderType !== 'ORDER_TYPE_VOICE' && $setup.callLevel >= 2 && $setup.vehicleTypeUnCheckedCount > 0 && 1 === 2 && !($setup.isMorningRushHour || $setup.isEveningRushHour) ? (_openBlock(), _createElementBlock("div", _hoisted_35, [$setup.vehicleTypeUnCheckedCount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36, "追加车型加快接单速度")) : _createCommentVNode("", true), $setup.vehicleTypeUnCheckedCount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vehicleTypes, (vehicleType, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "data",
      key: index
    }, [!vehicleType.checked ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: $event => $options.checkVehicleType(index),
      class: "vehicle-type-item"
    }, [_createElementVNode("img", {
      class: "icon",
      src: vehicleType.icon
    }, null, 8, _hoisted_39), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(vehicleType.name), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(vehicleType.description), 1)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_van_icon, {
      name: "info-o"
    }), _createTextVNode(" " + _toDisplayString(vehicleType.pricePrefix) + " ", 1), _createElementVNode("strong", null, _toDisplayString($setup.vehiclePrices[index] ? $setup.vehiclePrices[index] : '--'), 1), _createTextVNode(" 元 ")]), $setup.tolls && $setup.tolls > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createTextVNode(" 包含"), _createElementVNode("strong", null, _toDisplayString(parseFloat($setup.tolls).toFixed(2)), 1), _createTextVNode("元通行费 ")])) : _createCommentVNode("", true)]), _createElementVNode("img", {
      class: "checkbox",
      src: vehicleType.checked ? require('@/assets/icon/checked.png') : require('@/assets/icon/check.png'),
      onClick: _withModifiers($event => $options.checkVehicleType(index), ["stop"])
    }, null, 8, _hoisted_46)], 8, _hoisted_38)) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_47, [$setup.orderType !== 'ORDER_TYPE_VOICE' && 1 === 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass('options-item' + ($setup.paidPickUp ? ' selected' : '')),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.selectPaidPickUp && $options.selectPaidPickUp(...args))
  }, [_createVNode(_component_van_icon, {
    name: "underway-o"
  }), _createTextVNode("  打表来接 ")], 2)) : _createCommentVNode("", true), $setup.orderType !== 'ORDER_TYPE_VOICE' && 1 === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_48)) : _createCommentVNode("", true), $setup.orderType !== 'ORDER_TYPE_VOICE' && 1 === 2 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass('options-item' + ($setup.tip ? ' selected' : '')),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.clickShowTipForm && $options.clickShowTipForm(...args))
  }, [!$setup.tip ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    name: require('@/assets/icon/tip/tip.png')
  }, null, 8, ["name"])) : _createCommentVNode("", true), $setup.tip ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 1,
    name: require('@/assets/icon/tip/tip-blod.png')
  }, null, 8, ["name"])) : _createCommentVNode("", true), _createTextVNode("  调度费" + _toDisplayString($setup.tip ? $setup.tipAmount + '元' : ''), 1)], 2)) : _createCommentVNode("", true), $setup.orderType !== 'ORDER_TYPE_VOICE' ? (_openBlock(), _createElementBlock("div", _hoisted_49)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "options-item",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.cancelOrder && $options.cancelOrder(...args))
  }, [_createVNode(_component_van_icon, {
    name: "revoke"
  }), _createTextVNode("  取消订单 ")])])])])), [[_directive_height_animate]])]), _createVNode(_component_van_popup, {
    show: $setup.showTipForm,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showTipForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_tip_form, {
      amount: $setup.tipAmount,
      "cancel-click": $options.tipCancelClick,
      "enter-click": $options.tipEnterClick
    }, null, 8, ["amount", "cancel-click", "enter-click"])]),
    _: 1
  }, 8, ["show"])]);
}